"use client";

import { PAGES, TOKEN } from "@idss/libraries";
import { useCookies } from "next-client-cookies";
import { PropsWithChildren } from "react";

import { navigate } from "@/actions/navigate";

type LayoutProps = PropsWithChildren<{}>;

export default function Template({ children }: LayoutProps) {
  const cookies = useCookies();
  const tokenHeader = cookies.get(TOKEN.HEADER);

  if (tokenHeader) navigate(PAGES.DASHBOARD);
  return children;
}
